// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiAgentsToolsResult = objectOf({
  tools: arrayOf(
    objectOf({
      id: number,
      name: string,
      functions: arrayOf(objectOf({ name: string, description: string })),
    })
  ),
  agents: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
    })
  ),
});
